// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from '@hey-api/client-fetch';
import type { GetDisplayBannerTypeUsingGetData, GetDisplayBannerTypeUsingGetResponse, SaveBenefitNotificationApplicationInfoUsingPostData, SaveBenefitNotificationApplicationInfoUsingPostResponse, GetBenefitNotificationApplicationResultsUrlUsingGetData, GetBenefitNotificationApplicationResultsUrlUsingGetResponse, GetBenefitNotificationFitAnalysisUsingGetData, GetBenefitNotificationFitAnalysisUsingGetResponse, GetBenefitNotificationFitAnalysisResultUsingGetData, GetBenefitNotificationFitAnalysisResultUsingGetResponse, GetBenefitNotificationMainInfoUsingGetData, GetBenefitNotificationMainInfoUsingGetResponse, GetBenefitNotificationPrivatePolicyUrlUsingGetData, GetBenefitNotificationPrivatePolicyUrlUsingGetResponse, GetBenefitNotificationPrivacyUsageUrlUsingGetData, GetBenefitNotificationPrivacyUsageUrlUsingGetResponse, GetBenefitNotificationPublicServiceDetailUrlUsingGetData, GetBenefitNotificationPublicServiceDetailUrlUsingGetResponse, GetBenefitNotificationServiceUsageAgreementManagementUrlUsingGetData, GetBenefitNotificationServiceUsageAgreementManagementUrlUsingGetResponse, GetBenefitNotificationServiceUsageAgreementUrlUsingGetData, GetBenefitNotificationServiceUsageAgreementUrlUsingGetResponse, GetBenefitNotificationSituationManagementUrlUsingGetData, GetBenefitNotificationSituationManagementUrlUsingGetResponse, GetBenefitNotificationTermServiceUrlUsingGetData, GetBenefitNotificationTermServiceUrlUsingGetResponse, BestContentsListUsingGetData, BestContentsListUsingGetResponse, GetNewBestContentsListUsingGetData, GetNewBestContentsListUsingGetResponse, GetPopularBestContentsListUsingGetData, GetPopularBestContentsListUsingGetResponse, BestContentsUsingGetData, BestContentsUsingGetResponse, BestContentsFeedbackUsingGetData, BestContentsFeedbackUsingGetResponse, GetListChildcareRelatedPolicyUsingGetData, GetListChildcareRelatedPolicyUsingGetResponse, LogoutMemberUsingGetData, LogoutMemberUsingGetResponse, GetMemberUsingGetData, GetMemberUsingGetResponse, GetCommunityVoucherCategoryPolicyListUsingGetData, GetCommunityVoucherCategoryPolicyListUsingGetResponse, GetLatestCommunityListUsingGetData, GetLatestCommunityListUsingGetResponse, GetMyCommunityListUsingGetData, GetMyCommunityListUsingGetResponse, GetMyCommunityTypeListUsingGetData, GetMyCommunityTypeListUsingGetResponse, GetCommunityFreeTalkListUsingGetData, GetCommunityFreeTalkListUsingGetResponse, CreateCommunityFreeTalkUsingPostData, CreateCommunityFreeTalkUsingPostResponse, FeedbackCommunityFreeTalkUsingGetData, FeedbackCommunityFreeTalkUsingGetResponse, GetCommunityFreeTalkHotListUsingGetData, GetCommunityFreeTalkHotListUsingGetResponse, GetPopularCommunityFreeTalkListUsingGetData, GetPopularCommunityFreeTalkListUsingGetResponse, GetCommunityFreeTalkUsingGetData, GetCommunityFreeTalkUsingGetResponse, UpdateCommunityFreeTalkUsingPutData, UpdateCommunityFreeTalkUsingPutResponse, DeleteCommunityFreeTalkUsingPutData, DeleteCommunityFreeTalkUsingPutResponse, DeleteCommunityParticipantUsingDeleteData, DeleteCommunityParticipantUsingDeleteResponse, CheckCommunityParticipantUsingGetData, CheckCommunityParticipantUsingGetResponse, SaveCommunityParticipantUsingPostData, SaveCommunityParticipantUsingPostResponse, UpdateCommunityParticipantCheckedYnUsingPutData, UpdateCommunityParticipantCheckedYnUsingPutResponse, InviteCommunityParticipantUsingPutData, InviteCommunityParticipantUsingPutResponse, LiftCommunityParticipantUsingPutData, LiftCommunityParticipantUsingPutResponse, GetCommunityPolicyTalkListUsingGetData, GetCommunityPolicyTalkListUsingGetResponse, CreateCommunityPolicyTalkUsingPostData, CreateCommunityPolicyTalkUsingPostResponse, FeedbackCommunityPolicyTalkUsingGetData, FeedbackCommunityPolicyTalkUsingGetResponse, GetCommunityPolicyTalkHotListUsingGetData, GetCommunityPolicyTalkHotListUsingGetResponse, GetCommunityPolicyTalkPolicyApplyListUsingGetData, GetCommunityPolicyTalkPolicyApplyListUsingGetResponse, GetPopularCommunityPolicyTalkListUsingGetData, GetPopularCommunityPolicyTalkListUsingGetResponse, GetCommunityPolicyTalkUsingGetData, GetCommunityPolicyTalkUsingGetResponse, UpdateCommunityPolicyTalkUsingPutData, UpdateCommunityPolicyTalkUsingPutResponse, SaveCommentPickUsingPostData, SaveCommentPickUsingPostResponse, DeleteCommunityPolicyTalkUsingPutData, DeleteCommunityPolicyTalkUsingPutResponse, ReportCommunityUsingPostData, ReportCommunityUsingPostResponse, SaveCommunityVoucherUsingPostData, SaveCommunityVoucherUsingPostResponse, FeedbackCommunityVoucherUsingGetData, FeedbackCommunityVoucherUsingGetResponse, GetMyCommunityVoucherListUsingGetData, GetMyCommunityVoucherListUsingGetResponse, UpdateCommunityVoucherUsingPutData, UpdateCommunityVoucherUsingPutResponse, SaveVoucherCommentPickUsingPostData, SaveVoucherCommentPickUsingPostResponse, DeleteCommunityVoucherUsingPutData, DeleteCommunityVoucherUsingPutResponse, GetCommunityWelloNewsListUsingGetData, GetCommunityWelloNewsListUsingGetResponse, FeedbackCommunityWelloNewsUsingGetData, FeedbackCommunityWelloNewsUsingGetResponse, GetCommunityWelloNewsUsingGetData, GetCommunityWelloNewsUsingGetResponse, DislikeUsingGetData, DislikeUsingGetResponse, RemoveWishlistUsingDeleteData, RemoveWishlistUsingDeleteResponse, SaveWishlistUsingPostData, SaveWishlistUsingPostResponse, CheckDlpGyeonggiAccountUsingGetData, CheckDlpGyeonggiAccountUsingGetResponse, CheckDlpGyeonggiAccountIdUsingPostData, CheckDlpGyeonggiAccountIdUsingPostResponse, SaveDlpGyeonggiAccountUsingPostData, SaveDlpGyeonggiAccountUsingPostResponse, LoginDlpGyeonggiAccountUsingPostData, LoginDlpGyeonggiAccountUsingPostResponse, VerifyDlpGyeonggiAccountIdentificationUsingPostData, VerifyDlpGyeonggiAccountIdentificationUsingPostResponse, CheckDlpGyeonggiAccountIdentificationUsingPostData, CheckDlpGyeonggiAccountIdentificationUsingPostResponse, GetDlpSeoulAccountAndRequestLoginUsingPostData, GetDlpSeoulAccountAndRequestLoginUsingPostResponse, RequestDlpSeoulIdCheckUsingPostData, RequestDlpSeoulIdCheckUsingPostResponse, CreateAccountUsingPostData, CreateAccountUsingPostResponse, RequestLoginUsingPostData, RequestLoginUsingPostResponse, GetDlpSeoulMemberInfoUsingPostData, GetDlpSeoulMemberInfoUsingPostResponse, ChangeMemberPasswordUsingPutData, ChangeMemberPasswordUsingPutResponse, RequestDlpSeoulVerificationForPasswordUsingPostData, RequestDlpSeoulVerificationForPasswordUsingPostResponse, RequestDlpSeoulVerificationCheckForPasswordUsingPostData, RequestDlpSeoulVerificationCheckForPasswordUsingPostResponse, GetDetailTermsOfPrivacyUsingGetData, GetDetailTermsOfPrivacyUsingGetResponse, GetDetailTermsOfServiceUsingGetData, GetDetailTermsOfServiceUsingGetResponse, RequestDlpSeoulVerificationUsingPostData, RequestDlpSeoulVerificationUsingPostResponse, RequestDlpSeoulVerificationCheckUsingPostData, RequestDlpSeoulVerificationCheckUsingPostResponse, GetDlpSeoulAppliedPolicyListUsingPostData, GetDlpSeoulAppliedPolicyListUsingPostResponse, GetDlpSeoulCulturePassApplyUsingPostData, GetDlpSeoulCulturePassApplyUsingPostResponse, GetDlpSeoulCltrPassCheckUsingPostData, GetDlpSeoulCltrPassCheckUsingPostResponse, GetDlpSeoulIsltYoungSprtApplyUsingPostData, GetDlpSeoulIsltYoungSprtApplyUsingPostResponse, GetDlpSeoulIsltYoungSprtCheckUsingPostData, GetDlpSeoulIsltYoungSprtCheckUsingPostResponse, GetDlpSeoulLoanCrdtRcvrApplyUsingPostData, GetDlpSeoulLoanCrdtRcvrApplyUsingPostResponse, GetDlpSeoulLoanCrdtRcvrCheckUsingPostData, GetDlpSeoulLoanCrdtRcvrCheckUsingPostResponse, GetEVoucherProviderListUsingGetData, GetEVoucherProviderListUsingGetResponse, GetEVoucherProviderListAllUsingGetData, GetEVoucherProviderListAllUsingGetResponse, GetEVoucherProviderFeedbackUsingGetData, GetEVoucherProviderFeedbackUsingGetResponse, GetEVoucherProviderUsingGetData, GetEVoucherProviderUsingGetResponse, GetEmergencyRoomListUsingGetData, GetEmergencyRoomListUsingGetResponse, GetEmergencyRoomUsingGetData, GetEmergencyRoomUsingGetResponse, HometownNewsListUsingGetData, HometownNewsListUsingGetResponse, HometownNewsFeedbackUsingGetData, HometownNewsFeedbackUsingGetResponse, GetPopularHometownNewsListUsingGetData, GetPopularHometownNewsListUsingGetResponse, GetPopularHometownNewsListForCommunityUsingGetData, GetPopularHometownNewsListForCommunityUsingGetResponse, HometownNewsUsingGetData, HometownNewsUsingGetResponse, InquiryListUsingGetData, InquiryListUsingGetResponse, SaveInquiryUsingPostData, SaveInquiryUsingPostResponse, GetInquiryUsingGetData, GetInquiryUsingGetResponse, SendPinkeyUsingPostData, SendPinkeyUsingPostResponse, MemberAccountListUsingGetData, MemberAccountListUsingGetResponse, SaveMemberAccountUsingPostData, SaveMemberAccountUsingPostResponse, GetMemberAccountUsingGetData, GetMemberAccountUsingGetResponse, MemberCardListUsingGetData, MemberCardListUsingGetResponse, SaveMemberCardUsingPostData, SaveMemberCardUsingPostResponse, UpdateIssueAtUsingPutData, UpdateIssueAtUsingPutResponse, UploadCardImageUsingPutData, UploadCardImageUsingPutResponse, PutFitFilterUsingPostData, PutFitFilterUsingPostResponse, SaveFitFilterUsingPostData, SaveFitFilterUsingPostResponse, InterestFilterUsingGetData, InterestFilterUsingGetResponse, SaveInterestFilterUsingPostData, SaveInterestFilterUsingPostResponse, SaveKbFilterUsingPostData, SaveKbFilterUsingPostResponse, NoticeListUsingPostData, NoticeListUsingPostResponse, RequiredFilterUsingGetData, RequiredFilterUsingGetResponse, ResignMemberUsingDeleteData, ResignMemberUsingDeleteResponse, FileUploadUsingPostData, FileUploadUsingPostResponse, GetActionCountUsingGetData, GetActionCountUsingGetResponse, MemberContentCountUsingGetData, MemberContentCountUsingGetResponse, MemberInterestPolicyListUsingGetData, MemberInterestPolicyListUsingGetResponse, GetInvitedMemberCountUsingGetData, GetInvitedMemberCountUsingGetResponse, KbMemberCheckUsingPostData, KbMemberCheckUsingPostResponse, MessageReceiveUsingPutData, MessageReceiveUsingPutResponse, MemberNeighborPolicyListUsingGetData, MemberNeighborPolicyListUsingGetResponse, MemberPeerGroupPolicyListUsingGetData, MemberPeerGroupPolicyListUsingGetResponse, MemberPolicyListUsingGetData, MemberPolicyListUsingGetResponse, MemberUsingGetData, MemberUsingGetResponse, SaveMemberNickNameUsingPostData, SaveMemberNickNameUsingPostResponse, UpdateMemberNickNameUsingPutData, UpdateMemberNickNameUsingPutResponse, MemberRecentPolicyListUsingGetData, MemberRecentPolicyListUsingGetResponse, MemberRecommendPolicyByRecentListUsingGetData, MemberRecommendPolicyByRecentListUsingGetResponse, MemberNewPolicyListUsingGetData, MemberNewPolicyListUsingGetResponse, DeleteMemberSocialAccountsUsingDeleteData, DeleteMemberSocialAccountsUsingDeleteResponse, MemberSocialAccountsUsingGetData, MemberSocialAccountsUsingGetResponse, UpdateMemberVerificationUsingPutData, UpdateMemberVerificationUsingPutResponse, GetMemberTermAgreementByAgreementTypeUsingGetData, GetMemberTermAgreementByAgreementTypeUsingGetResponse, SaveOrUpdateMemberTermAgreementUsingPostData, SaveOrUpdateMemberTermAgreementUsingPostResponse, GetLatestCompletedCiUsingPostData, GetLatestCompletedCiUsingPostResponse, GetMemberVerificationIdUsingGetData, GetMemberVerificationIdUsingGetResponse, DecryptMemberVerificationUsingPostData, DecryptMemberVerificationUsingPostResponse, GetLatestCompletedUsingPostData, GetLatestCompletedUsingPostResponse, SendNiceSafeKeyUsingPostData, SendNiceSafeKeyUsingPostResponse, CheckPlusSendResultUsingGetData, CheckPlusSendResultUsingGetResponse, CheckPlusFailUsingGetData, CheckPlusFailUsingGetResponse, GetWelloMemberBlockListUsingGetData, GetWelloMemberBlockListUsingGetResponse, BlockWelloMemberByCommunityUsingPostData, BlockWelloMemberByCommunityUsingPostResponse, DeleteMemberWelloBlockUsingDeleteData, DeleteMemberWelloBlockUsingDeleteResponse, SendCertificationCellphoneUsingPostData, SendCertificationCellphoneUsingPostResponse, CertificationCheckUsingPostData, CertificationCheckUsingPostResponse, GetLocationServiceConsentUsingGetData, GetLocationServiceConsentUsingGetResponse, UpdateLocationServiceConsentUsingPutData, UpdateLocationServiceConsentUsingPutResponse, GetPrivateDataConsentUsingGetData, GetPrivateDataConsentUsingGetResponse, UpdatePrivateDataConsentUsingPutData, UpdatePrivateDataConsentUsingPutResponse, RejectMessageUsingPutData, RejectMessageUsingPutResponse, MetaPolicyListUsingGetData, MetaPolicyListUsingGetResponse, MetaPolicyFeedbackUsingGetData, MetaPolicyFeedbackUsingGetResponse, GetInterestPolicyListUsingGetData, GetInterestPolicyListUsingGetResponse, GetRelatedMetaPolicyListUsingGetData, GetRelatedMetaPolicyListUsingGetResponse, MetaPolicyUsingGetData, MetaPolicyUsingGetResponse, GetRecommendNearExpiryPolicyListUsingGetData, GetRecommendNearExpiryPolicyListUsingGetResponse, GetRecommendNearExpiryPolicyProvisionTypeAllListUsingGetData, GetRecommendNearExpiryPolicyProvisionTypeAllListUsingGetResponse, GetRecommendNewPolicyListUsingGetData, GetRecommendNewPolicyListUsingGetResponse, GetRecommendNewPolicyProvisionTypeAllListUsingGetData, GetRecommendNewPolicyProvisionTypeAllListUsingGetResponse, GetRecommendTrendingPolicyListUsingGetData, GetRecommendTrendingPolicyListUsingGetResponse, GetRecommendTrendingPolicyProvisionTypeAllListUsingGetData, GetRecommendTrendingPolicyProvisionTypeAllListUsingGetResponse, GetRecommendUnreadPolicyListUsingGetData, GetRecommendUnreadPolicyListUsingGetResponse, GetRecommendUnreadPolicyProvisionTypeAllListUsingGetData, GetRecommendUnreadPolicyProvisionTypeAllListUsingGetResponse, PaymentHisListUsingGetData, PaymentHisListUsingGetResponse, TotalPaymentHisListUsingGetData, TotalPaymentHisListUsingGetResponse, GetDetailPointBalanceUsingGetData, GetDetailPointBalanceUsingGetResponse, GetListPointAttendanceUsingGetData, GetListPointAttendanceUsingGetResponse, SaveTodayAttendanceUsingPostData, SaveTodayAttendanceUsingPostResponse, GetPointBudgetUsingGetData, GetPointBudgetUsingGetResponse, GetListPointHistoryUsingGetData, GetListPointHistoryUsingGetResponse, SavePointWithdrawalUsingPostData, SavePointWithdrawalUsingPostResponse, GetRandomTicketListUsingGetData, GetRandomTicketListUsingGetResponse, GetRandomTicketUsingGetData, GetRandomTicketUsingGetResponse, OpenRandomTicketUsingPutData, OpenRandomTicketUsingPutResponse, ReviewRandomTicketUsingPutData, ReviewRandomTicketUsingPutResponse, FileDeleteUsingDeleteData, FileDeleteUsingDeleteResponse, FileUploadUsingPost1Data, FileUploadUsingPost1Response, UpdateFileTempSaveYnUsingPutData, UpdateFileTempSaveYnUsingPutResponse, FileCopyUsingPostData, FileCopyUsingPostResponse, FileDecryptionDownloadUsingGetData, FileDecryptionDownloadUsingGetResponse, FileReUploadUsingPostData, FileReUploadUsingPostResponse, FileRenameUsingPutData, FileRenameUsingPutResponse, SituationListUsingGetData, SituationListUsingGetResponse, GetSituationPolicyListUsingGetData, GetSituationPolicyListUsingGetResponse, GetWebWelloAppPushListUsingGetData, GetWebWelloAppPushListUsingGetResponse, UpdateWelloAppPushReadUsingPutData, UpdateWelloAppPushReadUsingPutResponse, GetWelloApplyPolicyListUsingGetData, GetWelloApplyPolicyListUsingGetResponse, GetWelloCommentListUsingGetData, GetWelloCommentListUsingGetResponse, SaveWelloCommentUsingPostData, SaveWelloCommentUsingPostResponse, GetLiveWelloCommentListUsingGetData, GetLiveWelloCommentListUsingGetResponse, GetMyWelloCommentListUsingGetData, GetMyWelloCommentListUsingGetResponse, GetMetaPolicyCommentListUsingGetData, GetMetaPolicyCommentListUsingGetResponse, UpdateWelloCommentUsingPutData, UpdateWelloCommentUsingPutResponse, DeleteWelloCommentUsingPutData, DeleteWelloCommentUsingPutResponse, SaveWelloCommentReportUsingPostData, SaveWelloCommentReportUsingPostResponse, SaveWelloDeviceInfoUsingPostData, SaveWelloDeviceInfoUsingPostResponse, SaveWelloHelperUsingPostData, SaveWelloHelperUsingPostResponse, DeleteWelloLikeUsingDeleteData, DeleteWelloLikeUsingDeleteResponse, SaveWelloLikeUsingPostData, SaveWelloLikeUsingPostResponse, GetListLikeContentsUsingGetData, GetListLikeContentsUsingGetResponse, GetListLikeContentsTypeUsingGetData, GetListLikeContentsTypeUsingGetResponse, DeleteWelloMemberFamilyUsingDeleteData, DeleteWelloMemberFamilyUsingDeleteResponse, GetWelloMemberFamilyUsingGetData, GetWelloMemberFamilyUsingGetResponse, SaveWelloMemberFamilyUsingPostData, SaveWelloMemberFamilyUsingPostResponse, UpdateWelloMemberFamilyUsingPutData, UpdateWelloMemberFamilyUsingPutResponse, SaveWelloParticipationUsingPostData, SaveWelloParticipationUsingPostResponse, WelloPickListUsingGetData, WelloPickListUsingGetResponse, WelloPickPolicyListUsingGetData, WelloPickPolicyListUsingGetResponse, CheckWelloPolicyApplyUsingGetData, CheckWelloPolicyApplyUsingGetResponse, GetWelloPolicyApplyListUsingGetData, GetWelloPolicyApplyListUsingGetResponse, GetWelloPolicyApplyCountUsingGetData, GetWelloPolicyApplyCountUsingGetResponse, SaveReportUsingPostData, SaveReportUsingPostResponse, SaveWelloTrackingUsingPostData, SaveWelloTrackingUsingPostResponse, DeleteWishlistUsingDeleteData, DeleteWishlistUsingDeleteResponse, SaveWishlistUsingPost1Data, SaveWishlistUsingPost1Response, BestContentsWishlistUsingGetData, BestContentsWishlistUsingGetResponse, GetCommunityWishlistUsingGetData, GetCommunityWishlistUsingGetResponse, GetCommunityPolicyTalkWishlistUsingGetData, GetCommunityPolicyTalkWishlistUsingGetResponse, GetCommunityWelloNewsWishlistUsingGetData, GetCommunityWelloNewsWishlistUsingGetResponse, GetEmergencyRoomWishlistUsingGetData, GetEmergencyRoomWishlistUsingGetResponse, HometownNewsWishlistUsingGetData, HometownNewsWishlistUsingGetResponse, MetaPolicyWishlistUsingGetData, MetaPolicyWishlistUsingGetResponse, VoucherProviderWishlistUsingGetData, VoucherProviderWishlistUsingGetResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * 노출할 배너 타입 조회
 * 상단에 노출할 배너 타입을 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbanner = <ThrowOnError extends boolean = false>(options?: Options<GetDisplayBannerTypeUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDisplayBannerTypeUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/banner',
        ...options
    });
};

/**
 * 혜택 알리미 - 신청 정보 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHinfo = <ThrowOnError extends boolean = false>(options?: Options<SaveBenefitNotificationApplicationInfoUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveBenefitNotificationApplicationInfoUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/application-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 혜택 알리미 - 신청 결과 목록 화면 URL 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHresultsDASHurl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationApplicationResultsUrlUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBenefitNotificationApplicationResultsUrlUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/application-results-url',
        ...options
    });
};

/**
 * 혜택 알리미 - 6. 맞춤 분석 요청
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysis = <ThrowOnError extends boolean = false>(options?: Options<GetBenefitNotificationFitAnalysisUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBenefitNotificationFitAnalysisUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/fit-analysis',
        ...options
    });
};

/**
 * 혜택 알리미 - 맞춤 맞춤분석 요청 및 결과 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisDASHresult = <ThrowOnError extends boolean = false>(options?: Options<GetBenefitNotificationFitAnalysisResultUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBenefitNotificationFitAnalysisResultUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/fit-analysis-result',
        ...options
    });
};

/**
 * 혜택 알리미 - 2. 혜택알리미 메인 정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHmainDASHinfo = <ThrowOnError extends boolean = false>(options?: Options<GetBenefitNotificationMainInfoUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBenefitNotificationMainInfoUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/main-info',
        ...options
    });
};

/**
 * 혜택알리미 - 3. 혜택알리미 안내 화면 URL 조회 - 개인정보 처리방침
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHpolicyDASHurl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationPrivatePolicyUrlUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBenefitNotificationPrivatePolicyUrlUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/privacy-policy-url',
        ...options
    });
};

/**
 * 혜택알리미 - 17. 개인정보 활용이력 화면 URL 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHusageDASHurl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationPrivacyUsageUrlUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBenefitNotificationPrivacyUsageUrlUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/privacy-usage-url',
        ...options
    });
};

/**
 * 혜택 알리미 - 공공서비스 상세 화면 URL 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHpublicDASHserviceDASHdetailDASHurl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationPublicServiceDetailUrlUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBenefitNotificationPublicServiceDetailUrlUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/public-service-detail-url',
        ...options
    });
};

/**
 * 혜택알리미 - 16. 서비스 이용 동의 관리 화면 URL 조회 (서비스 이용동의/철회)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHmanagementDASHurl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationServiceUsageAgreementManagementUrlUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBenefitNotificationServiceUsageAgreementManagementUrlUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/service-usage-agreement-management-url',
        ...options
    });
};

/**
 * 혜택 알리미 - 1. 서비스 이용 동의 화면 URL 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHurl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationServiceUsageAgreementUrlUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBenefitNotificationServiceUsageAgreementUrlUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/service-usage-agreement-url',
        ...options
    });
};

/**
 * 혜택알리미 - 13. 상황 인지데이터 화면 URL 조회(현재 상황 설정 화면 url)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHsituationDASHmanagementDASHurl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationSituationManagementUrlUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBenefitNotificationSituationManagementUrlUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/situation-management-url',
        ...options
    });
};

/**
 * 혜택알리미 - 3. 혜택알리미 안내 화면 URL 조회 - 이용 약관 화면
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHtermDASHserviceDASHurl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationTermServiceUrlUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBenefitNotificationTermServiceUrlUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/benefit-notification/term-service-url',
        ...options
    });
};

/**
 * 정책 소식 목록 조회
 * 정책 소식 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbest = <ThrowOnError extends boolean = false>(options: Options<BestContentsListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BestContentsListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/best',
        ...options
    });
};

/**
 * 신규 정책 소식 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHnew = <ThrowOnError extends boolean = false>(options?: Options<GetNewBestContentsListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNewBestContentsListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/best/new',
        ...options
    });
};

/**
 * 인기 정책 소식 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<GetPopularBestContentsListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularBestContentsListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/best/popular',
        ...options
    });
};

/**
 * 정책 소식 상세 조회
 * 정책 소식 상세 정보를 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<BestContentsUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BestContentsUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/best/{best_contents_id_idx}',
        ...options
    });
};

/**
 * 로그인 멤버 정책 소식 좋아요&스크랩 정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<BestContentsFeedbackUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BestContentsFeedbackUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/feedback/{best_contents_id}',
        ...options
    });
};

/**
 * 내 상황에 맞는 육아 정책 관련 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicy = <ThrowOnError extends boolean = false>(options: Options<GetListChildcareRelatedPolicyUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetListChildcareRelatedPolicyUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy-case/baby/related-policy',
        ...options
    });
};

/**
 * 사용자 로그아웃
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHlogout = <ThrowOnError extends boolean = false>(options?: Options<LogoutMemberUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LogoutMemberUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/common/member-oauth/logout',
        ...options
    });
};

/**
 * 웰로 회원 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHmyDASHinfo = <ThrowOnError extends boolean = false>(options?: Options<GetMemberUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMemberUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/common/member-oauth/my-info',
        ...options
    });
};

/**
 * 커뮤니티 - 카테고리에 해당되는 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicy = <ThrowOnError extends boolean = false>(options: Options<GetCommunityVoucherCategoryPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityVoucherCategoryPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/category/{community_category_id}/policy',
        ...options
    });
};

/**
 * 커뮤니티 최신글
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHlatest = <ThrowOnError extends boolean = false>(options?: Options<GetLatestCommunityListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetLatestCommunityListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/latest',
        ...options
    });
};

/**
 * 내가 작성한 커뮤니티 글
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmy = <ThrowOnError extends boolean = false>(options: Options<GetMyCommunityListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMyCommunityListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/my',
        ...options
    });
};

/**
 * 내가 작성한 커뮤니티 글 유형
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmySLASHtype = <ThrowOnError extends boolean = false>(options?: Options<GetMyCommunityTypeListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMyCommunityTypeListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/my/type',
        ...options
    });
};

/**
 * 커뮤니티 - 자유 수다 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalk = <ThrowOnError extends boolean = false>(options: Options<GetCommunityFreeTalkListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityFreeTalkListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/free-talk',
        ...options
    });
};

/**
 * 커뮤니티 - 자유 수다 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalk = <ThrowOnError extends boolean = false>(options?: Options<CreateCommunityFreeTalkUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CreateCommunityFreeTalkUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/free-talk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 자유 수다 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityFreeTalkUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeedbackCommunityFreeTalkUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/free-talk/feedback/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - HOT한 수다 - 자유수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhot = <ThrowOnError extends boolean = false>(options: Options<GetCommunityFreeTalkHotListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityFreeTalkHotListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/free-talk/hot',
        ...options
    });
};

/**
 * 커뮤니티 - 인기 자유수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<GetPopularCommunityFreeTalkListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularCommunityFreeTalkListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/free-talk/popular',
        ...options
    });
};

/**
 * 커뮤니티 - 자유 수다 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetCommunityFreeTalkUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityFreeTalkUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/free-talk/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 자유 수다 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<UpdateCommunityFreeTalkUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCommunityFreeTalkUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/free-talk/{community_id_idx}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 자유 수다 삭제
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete = <ThrowOnError extends boolean = false>(options: Options<DeleteCommunityFreeTalkUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DeleteCommunityFreeTalkUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/free-talk/{community_id_idx}/delete',
        ...options
    });
};

/**
 * 커뮤니티 - 대기 참여자 참여 취소
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant = <ThrowOnError extends boolean = false>(options?: Options<DeleteCommunityParticipantUsingDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteCommunityParticipantUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/participant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 커뮤니티 참여 여부 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant = <ThrowOnError extends boolean = false>(options?: Options<CheckCommunityParticipantUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CheckCommunityParticipantUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/participant',
        ...options
    });
};

/**
 * 커뮤니티 - 커뮤니티 참여 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant = <ThrowOnError extends boolean = false>(options?: Options<SaveCommunityParticipantUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveCommunityParticipantUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/participant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 참여자 초대 확인 요청
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHinvitationDASHcheck = <ThrowOnError extends boolean = false>(options?: Options<UpdateCommunityParticipantCheckedYnUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateCommunityParticipantCheckedYnUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/participant/invitation-check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 커뮤니티 참여 초대
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHinvite = <ThrowOnError extends boolean = false>(options?: Options<InviteCommunityParticipantUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<InviteCommunityParticipantUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/participant/invite',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 대기 참여자 최신으로 끌어올리기
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHlift = <ThrowOnError extends boolean = false>(options?: Options<LiftCommunityParticipantUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<LiftCommunityParticipantUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/participant/lift',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 정책 수다 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalk = <ThrowOnError extends boolean = false>(options: Options<GetCommunityPolicyTalkListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityPolicyTalkListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk',
        ...options
    });
};

/**
 * 커뮤니티 - 정책 수다 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalk = <ThrowOnError extends boolean = false>(options?: Options<CreateCommunityPolicyTalkUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CreateCommunityPolicyTalkUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 정책 수다 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityPolicyTalkUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeedbackCommunityPolicyTalkUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk/feedback/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - HOT한 수다 - 정책수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhot = <ThrowOnError extends boolean = false>(options: Options<GetCommunityPolicyTalkHotListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityPolicyTalkHotListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk/hot',
        ...options
    });
};

/**
 * 커뮤니티 - 정책수다 간편신청 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapply = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityPolicyTalkPolicyApplyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityPolicyTalkPolicyApplyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk/policy-apply',
        ...options
    });
};

/**
 * 커뮤니티 - 인기 정책수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<GetPopularCommunityPolicyTalkListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularCommunityPolicyTalkListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk/popular',
        ...options
    });
};

/**
 * 커뮤니티 - 정책 수다 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetCommunityPolicyTalkUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityPolicyTalkUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 정책 수다 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<UpdateCommunityPolicyTalkUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCommunityPolicyTalkUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk/{community_id_idx}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 정책 수다 댓글 채택 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentIdRBRACESLASHcommentDASHpick = <ThrowOnError extends boolean = false>(options: Options<SaveCommentPickUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveCommentPickUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk/{community_id_idx}/comment/{commentId}/comment-pick',
        ...options
    });
};

/**
 * 커뮤니티 - 정책 수다 삭제
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete = <ThrowOnError extends boolean = false>(options: Options<DeleteCommunityPolicyTalkUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DeleteCommunityPolicyTalkUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/policy-talk/{community_id_idx}/delete',
        ...options
    });
};

/**
 * 커뮤니티 게시글 신고
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACESLASHreport = <ThrowOnError extends boolean = false>(options: Options<ReportCommunityUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReportCommunityUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/{community_id}/report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 바우처 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucher = <ThrowOnError extends boolean = false>(options?: Options<SaveCommunityVoucherUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveCommunityVoucherUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/voucher',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 바우처 피드백
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityVoucherUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeedbackCommunityVoucherUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/voucher/feedback/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 내가 작성한 바우처 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHmy = <ThrowOnError extends boolean = false>(options?: Options<GetMyCommunityVoucherListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMyCommunityVoucherListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/voucher/my',
        ...options
    });
};

/**
 * 커뮤니티 - 바우처 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<UpdateCommunityVoucherUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateCommunityVoucherUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/voucher/{community_id_idx}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 바우처 답글 채택 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentUNDERSCOREidRBRACESLASHcommentDASHpick = <ThrowOnError extends boolean = false>(options: Options<SaveVoucherCommentPickUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveVoucherCommentPickUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/voucher/{community_id_idx}/comment/{comment_id}/comment-pick',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 커뮤니티 - 바우처 삭제
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete = <ThrowOnError extends boolean = false>(options: Options<DeleteCommunityVoucherUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DeleteCommunityVoucherUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/voucher/{community_id_idx}/delete',
        ...options
    });
};

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnews = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityWelloNewsListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/wello-news',
        ...options
    });
};

/**
 * 커뮤니티 - 웰로 뉴스 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityWelloNewsUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeedbackCommunityWelloNewsUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/wello-news/feedback/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 웰로 뉴스 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityWelloNewsUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/community/wello-news/{community_id_idx}',
        ...options
    });
};

/**
 * 제외정책 목록조회
 * 제외정책 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislike = <ThrowOnError extends boolean = false>(options?: Options<DislikeUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DislikeUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/dislike',
        ...options
    });
};

/**
 * 제외정책-삭제
 * 제외정책을 삭제합니다
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<RemoveWishlistUsingDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveWishlistUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/dislike/{policy_id}',
        ...options
    });
};

/**
 * 제외정책 등록
 * 제외정책을 등록합니다
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<SaveWishlistUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveWishlistUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/dislike/{policy_id}',
        ...options
    });
};

/**
 * 계정정보 확인 및 로그인
 * 계정정보가 있는지 확인 후 로그인을 시도합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccount = <ThrowOnError extends boolean = false>(options?: Options<CheckDlpGyeonggiAccountUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CheckDlpGyeonggiAccountUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/gyeonggi/account',
        ...options
    });
};

/**
 * 가입 과정 Step 2 - 아이디 중복 확인
 * 아이디가 사용 가능한 지 확인합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHidSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<CheckDlpGyeonggiAccountIdUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CheckDlpGyeonggiAccountIdUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/gyeonggi/account/id/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 가입 과정 Step 3 - 회원 가입 진행
 * 주어진 정보로 회원가입을 진행합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHjoin = <ThrowOnError extends boolean = false>(options?: Options<SaveDlpGyeonggiAccountUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveDlpGyeonggiAccountUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/gyeonggi/account/join',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 로그인
 * ID, PW 으로 로그인 합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHlogin = <ThrowOnError extends boolean = false>(options?: Options<LoginDlpGyeonggiAccountUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LoginDlpGyeonggiAccountUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/gyeonggi/account/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 가입 과정 Step 1.1 - 본인인증
 * 휴대폰 본인인증을 합니다. 사용자 ID 을 찾는데도 사용할 수 있습니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverification = <ThrowOnError extends boolean = false>(options?: Options<VerifyDlpGyeonggiAccountIdentificationUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<VerifyDlpGyeonggiAccountIdentificationUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/gyeonggi/account/verification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 가입 과정 Step 1.2 - 본인인증 확인 및 가입 여부 확인
 * SMS 인증 코드 값을 입력해 가입 여부를 확인하고 다음 단계를 진행할 준비를 합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<CheckDlpGyeonggiAccountIdentificationUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CheckDlpGyeonggiAccountIdentificationUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/gyeonggi/account/verification/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 계정 확인 및 로그인
 * 서울특별시 계정 저장 여부를 반환하고 로그인을 시도합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccount = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulAccountAndRequestLoginUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulAccountAndRequestLoginUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account',
        ...options
    });
};

/**
 * DLP 서울특별시 아이디 중복 확인 요청
 * 서울특별시 아이디 중복 확인을 시도합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHidSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<RequestDlpSeoulIdCheckUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RequestDlpSeoulIdCheckUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/id/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 회원가입 요청
 * 서울특별시 회원가입을 시도합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHjoin = <ThrowOnError extends boolean = false>(options?: Options<CreateAccountUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CreateAccountUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/join',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 로그인 요청
 * 서울특별시 로그인 요청을 시도합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHlogin = <ThrowOnError extends boolean = false>(options?: Options<RequestLoginUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RequestLoginUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 관련 회원 정보 조회
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHmemberDASHinfo = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulMemberInfoUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulMemberInfoUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/member-info',
        ...options
    });
};

/**
 * DLP 서울특별시 비밀번호 변경 요청
 * 서울특별시 비밀번호 변경을 시도합니다.
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpassword = <ThrowOnError extends boolean = false>(options?: Options<ChangeMemberPasswordUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<ChangeMemberPasswordUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 비밀번호 변경 본인인증 요청
 * 서울특별시 비밀번호 변경 본인인증을 시도합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverification = <ThrowOnError extends boolean = false>(options?: Options<RequestDlpSeoulVerificationForPasswordUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RequestDlpSeoulVerificationForPasswordUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/password-verification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 비밀번호 변경 본인인증 확인 요청
 * 서울특별시 비밀번호 변경 본인인증 확인을 시도합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<RequestDlpSeoulVerificationCheckForPasswordUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RequestDlpSeoulVerificationCheckForPasswordUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/password-verification/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 개인정보 수집이용내역 요청
 * 서울특별시 개인정보 수집이용내역을 요청합니다..
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHprivacyDASHpolicyDASHfirst = <ThrowOnError extends boolean = false>(options?: Options<GetDetailTermsOfPrivacyUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDetailTermsOfPrivacyUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/privacy-policy-first',
        ...options
    });
};

/**
 * DLP 서울특별시 이용약관 요청
 * 서울특별시 이용약관 정보를 요청합니다..
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHtermsDASHofDASHservice = <ThrowOnError extends boolean = false>(options?: Options<GetDetailTermsOfServiceUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDetailTermsOfServiceUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/terms-of-service',
        ...options
    });
};

/**
 * DLP 서울특별시 본인인증 요청
 * 서울특별시 본인인증을 시도합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverification = <ThrowOnError extends boolean = false>(options?: Options<RequestDlpSeoulVerificationUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RequestDlpSeoulVerificationUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/verification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 본인인증 확인 요청
 * 서울특별시 본인인증 확인을 시도합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<RequestDlpSeoulVerificationCheckUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RequestDlpSeoulVerificationCheckUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/account/verification/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 신청한 정책 보기
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHappliedDASHpolicyDASHlist = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulAppliedPolicyListUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulAppliedPolicyListUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/applied-policy-list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 청년문화 패스 신청
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHapply = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulCulturePassApplyUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulCulturePassApplyUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/cltr-pass/apply',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 청년문화 패스 주민번호 사전 확인 요청
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulCltrPassCheckUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulCltrPassCheckUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/cltr-pass/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 고립•은둔청년 지원사업 신청
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHapply = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulIsltYoungSprtApplyUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulIsltYoungSprtApplyUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/islt-youth-sprt/apply',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 고립•은둔청년 지원사업 주민번호 사전 확인 요청
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulIsltYoungSprtCheckUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulIsltYoungSprtCheckUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/islt-youth-sprt/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 학자금대출 신용회복 신청
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHapply = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulLoanCrdtRcvrApplyUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulLoanCrdtRcvrApplyUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/loan-crdt-rcvr/apply',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * DLP 서울특별시 학자금대출 신용회복 주민번호 사전 확인 요청
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<GetDlpSeoulLoanCrdtRcvrCheckUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetDlpSeoulLoanCrdtRcvrCheckUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/dlp/seoul/loan-crdt-rcvr/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 위경도 기반 제공기관 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHprovider = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/voucher/provider',
        ...options
    });
};

/**
 * 위경도 기반 제공기관 전체 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHall = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderListAllUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderListAllUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/voucher/provider/all',
        ...options
    });
};

/**
 * 제공기관 피드백 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderFeedbackUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderFeedbackUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/voucher/provider/feedback/{id}',
        ...options
    });
};

/**
 * 제공기관 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/voucher/provider/{provider_uuid}',
        ...options
    });
};

/**
 * 병원 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroom = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEmergencyRoomListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        querySerializer: {
            array: {
                explode: false,
                style: 'form'
            }
        },
        url: '/wello/v2/auth/emergency-room',
        ...options
    });
};

/**
 * 병원 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEmergencyRoomUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/emergency-room/{emergencyRoomId}',
        ...options
    });
};

/**
 * 동네 소식 콘텐츠 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnews = <ThrowOnError extends boolean = false>(options: Options<HometownNewsListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<HometownNewsListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/hometown-news',
        ...options
    });
};

/**
 * 로그인 멤버 동네 소식 좋아요&스크랩 정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<HometownNewsFeedbackUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<HometownNewsFeedbackUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/hometown-news/feedback/{hometown_news_id}',
        ...options
    });
};

/**
 * 인기 동네 소식 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<GetPopularHometownNewsListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularHometownNewsListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/hometown-news/popular',
        ...options
    });
};

/**
 * 커뮤니티 인기 동네 소식 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularSLASHcommunity = <ThrowOnError extends boolean = false>(options?: Options<GetPopularHometownNewsListForCommunityUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularHometownNewsListForCommunityUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/hometown-news/popular/community',
        ...options
    });
};

/**
 * 동네 소식 콘텐츠 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<HometownNewsUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<HometownNewsUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/hometown-news/{hometown_news_id_idx}',
        ...options
    });
};

/**
 * 문의내역 조회
 * 문의 내역을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiry = <ThrowOnError extends boolean = false>(options: Options<InquiryListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<InquiryListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/cs/inquiry',
        ...options
    });
};

/**
 * 문의하기
 * 문의내용을 등록합니다
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiry = <ThrowOnError extends boolean = false>(options?: Options<SaveInquiryUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveInquiryUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/cs/inquiry',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 문의상세 조회
 * 문의 상세 내역을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquirySLASHLBRACEinquiryUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetInquiryUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInquiryUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/cs/inquiry/{inquiry_id}',
        ...options
    });
};

/**
 * 포스트백 신호(Pinkey) 전달
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHkb = <ThrowOnError extends boolean = false>(options?: Options<SendPinkeyUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SendPinkeyUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/kb',
        ...options
    });
};

/**
 * 계좌 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccount = <ThrowOnError extends boolean = false>(options?: Options<MemberAccountListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberAccountListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-account',
        ...options
    });
};

/**
 * 계좌 등록/변경
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccount = <ThrowOnError extends boolean = false>(options: Options<SaveMemberAccountUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveMemberAccountUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-account',
        ...options
    });
};

/**
 * 사용 가능한 계좌 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountSLASHavailable = <ThrowOnError extends boolean = false>(options?: Options<GetMemberAccountUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMemberAccountUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-account/available',
        ...options
    });
};

/**
 * 카드 신청 여정 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard = <ThrowOnError extends boolean = false>(options?: Options<MemberCardListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberCardListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-card',
        ...options
    });
};

/**
 * 카드 신청
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard = <ThrowOnError extends boolean = false>(options: Options<SaveMemberCardUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveMemberCardUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-card',
        ...options
    });
};

/**
 * 카드를 발급 받았어요
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard = <ThrowOnError extends boolean = false>(options: Options<UpdateIssueAtUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateIssueAtUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-card',
        ...options
    });
};

/**
 * 카드를 발급 받았어요-카드뒷면 업로드
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardSLASHcardDASHimage = <ThrowOnError extends boolean = false>(options: Options<UploadCardImageUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UploadCardImageUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-card/card-image',
        ...options
    });
};

/**
 * 맞춤 정보 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfit = <ThrowOnError extends boolean = false>(options?: Options<PutFitFilterUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PutFitFilterUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-filter/fit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 회원가입 맞춤 정보 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitDASHnew = <ThrowOnError extends boolean = false>(options?: Options<SaveFitFilterUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveFitFilterUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-filter/fit-new',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 관심 필터 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterest = <ThrowOnError extends boolean = false>(options?: Options<InterestFilterUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<InterestFilterUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-filter/interest',
        ...options
    });
};

/**
 * 관심 필터 코드 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterest = <ThrowOnError extends boolean = false>(options?: Options<SaveInterestFilterUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveInterestFilterUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-filter/interest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 *  KB 기본 필터 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHkb = <ThrowOnError extends boolean = false>(options?: Options<SaveKbFilterUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveKbFilterUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-filter/kb',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 지역 필터 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHregion = <ThrowOnError extends boolean = false>(options?: Options<NoticeListUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<NoticeListUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-filter/region',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 필터 조회(관심필터 제외)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHrequired = <ThrowOnError extends boolean = false>(options?: Options<RequiredFilterUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RequiredFilterUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-filter/required',
        ...options
    });
};

/**
 * 회원 탈퇴
 * 회원 탈퇴요청을 처리합니다
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmember = <ThrowOnError extends boolean = false>(options?: Options<ResignMemberUsingDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<ResignMemberUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 유저 프로필 이미지 업로드
 * 유저 프로필 이미지를 업로드 한다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmember = <ThrowOnError extends boolean = false>(options?: Options<FileUploadUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<FileUploadUsingPostResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * 유저의 행동 관련 수치 조회
 * 유저의 맞춤 정책, 스크랩 목록 수를 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHactionDASHcount = <ThrowOnError extends boolean = false>(options?: Options<GetActionCountUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetActionCountUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/action-count',
        ...options
    });
};

/**
 * 메인 페이지 멤버 컨텐츠 별 건수
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHcontentDASHcount = <ThrowOnError extends boolean = false>(options?: Options<MemberContentCountUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberContentCountUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/content-count',
        ...options
    });
};

/**
 * 회원 관심 분야별 맞춤정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinterestSLASHpolicy = <ThrowOnError extends boolean = false>(options?: Options<MemberInterestPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberInterestPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/interest/policy',
        ...options
    });
};

/**
 * 유저가 초대한 회원 수 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinvitedDASHmemberDASHcount = <ThrowOnError extends boolean = false>(options?: Options<GetInvitedMemberCountUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetInvitedMemberCountUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/invited-member-count',
        ...options
    });
};

/**
 * KB 연동 체크
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHkbDASHmemberDASHcheck = <ThrowOnError extends boolean = false>(options?: Options<KbMemberCheckUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<KbMemberCheckUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/kb-member-check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 알림수신여부 수정
 * 알림수신 여부를 수정합니다
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHmessageDASHreceive = <ThrowOnError extends boolean = false>(options?: Options<MessageReceiveUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<MessageReceiveUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/message-receive',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 우리 동네 이웃이 많이 본 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHneighborSLASHpolicy = <ThrowOnError extends boolean = false>(options?: Options<MemberNeighborPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberNeighborPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/neighbor/policy',
        ...options
    });
};

/**
 * 내 또래가 많이 본 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpeerDASHgroupSLASHpolicy = <ThrowOnError extends boolean = false>(options?: Options<MemberPeerGroupPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberPeerGroupPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/peer-group/policy',
        ...options
    });
};

/**
 * 지원유형별 맞춤정책 건수
 * 지원유형별 맞춤정책 건수를 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpolicySLASHprovisionDASHtypeDASHcount = <ThrowOnError extends boolean = false>(options?: Options<MemberPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/policy/provision-type-count',
        ...options
    });
};

/**
 * 유저 프로필 조회
 * 가입된 유저의 프로필을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile = <ThrowOnError extends boolean = false>(options?: Options<MemberUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/profile',
        ...options
    });
};

/**
 * 유저 가입정보 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile = <ThrowOnError extends boolean = false>(options?: Options<SaveMemberNickNameUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveMemberNickNameUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 유저 정보 수정
 * 가입된 유저 정보를 수정합니다
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile = <ThrowOnError extends boolean = false>(options?: Options<UpdateMemberNickNameUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateMemberNickNameUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 최근 본 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHpolicy = <ThrowOnError extends boolean = false>(options?: Options<MemberRecentPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberRecentPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/recent/policy',
        ...options
    });
};

/**
 * 내가 본 정책과 비슷한 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHrecommendSLASHpolicy = <ThrowOnError extends boolean = false>(options?: Options<MemberRecommendPolicyByRecentListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberRecommendPolicyByRecentListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/recent/recommend/policy',
        ...options
    });
};

/**
 * 회원 신규 맞춤정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicy = <ThrowOnError extends boolean = false>(options: Options<MemberNewPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MemberNewPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/recommend/policy',
        ...options
    });
};

/**
 * 연동된 소셜계정 해제
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccounts = <ThrowOnError extends boolean = false>(options?: Options<DeleteMemberSocialAccountsUsingDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteMemberSocialAccountsUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/social-accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 연동된 소셜계정 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccounts = <ThrowOnError extends boolean = false>(options?: Options<MemberSocialAccountsUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MemberSocialAccountsUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/social-accounts',
        ...options
    });
};

/**
 * 본인인증 ID로 유저정보 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHverification = <ThrowOnError extends boolean = false>(options?: Options<UpdateMemberVerificationUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateMemberVerificationUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/verification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 약관 동의 여부 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreement = <ThrowOnError extends boolean = false>(options: Options<GetMemberTermAgreementByAgreementTypeUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMemberTermAgreementByAgreementTypeUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-term-agreement',
        ...options
    });
};

/**
 * 약관 동의 저장/수정
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreement = <ThrowOnError extends boolean = false>(options?: Options<SaveOrUpdateMemberTermAgreementUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveOrUpdateMemberTermAgreementUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-term-agreement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 최근 인증된 멤버 CI 조회
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverification = <ThrowOnError extends boolean = false>(options?: Options<GetLatestCompletedCiUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetLatestCompletedCiUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-verification',
        ...options
    });
};

/**
 * 본인인증 ID 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<GetMemberVerificationIdUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMemberVerificationIdUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-verification/check',
        ...options
    });
};

/**
 * 본인인증 정보 복호화
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHdecrypt = <ThrowOnError extends boolean = false>(options?: Options<DecryptMemberVerificationUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<DecryptMemberVerificationUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-verification/decrypt',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 최근 인증된 멤버 정보 조회
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHinfo = <ThrowOnError extends boolean = false>(options?: Options<GetLatestCompletedUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetLatestCompletedUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-verification/info',
        ...options
    });
};

/**
 * Nice SafeKey 발급요청
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkey = <ThrowOnError extends boolean = false>(options?: Options<SendNiceSafeKeyUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SendNiceSafeKeyUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/nice-safe-key',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Nice 신용인증 성공시 이동될 URL
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusDASHsendDASHresult = <ThrowOnError extends boolean = false>(options?: Options<CheckPlusSendResultUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CheckPlusSendResultUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/nice-safe-key/check-plus-send-result',
        ...options
    });
};

/**
 * Nice 신용인증 실패시 이동될 URL
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREfail = <ThrowOnError extends boolean = false>(options?: Options<CheckPlusFailUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CheckPlusFailUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/nice-safe-key/check-plus_fail',
        ...options
    });
};

/**
 * 웰로 사용자 차단 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblock = <ThrowOnError extends boolean = false>(options: Options<GetWelloMemberBlockListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWelloMemberBlockListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-wello/block',
        ...options
    });
};

/**
 * 웰로 사용자 차단 - By Community
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHbyDASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<BlockWelloMemberByCommunityUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BlockWelloMemberByCommunityUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-wello/block/by-community/{community_id}',
        ...options
    });
};

/**
 * 웰로 사용자 차단 해제 - 삭제
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHLBRACEblockedUNDERSCOREmemberUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberWelloBlockUsingDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMemberWelloBlockUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-wello/block/{blocked_member_id}',
        ...options
    });
};

/**
 * 휴대전화번호 인증 발송
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcellphone = <ThrowOnError extends boolean = false>(options?: Options<SendCertificationCellphoneUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SendCertificationCellphoneUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/certification/cellphone',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 인증 번호 확인
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<CertificationCheckUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CertificationCheckUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/certification/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 위치 기반 동의 여부 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsent = <ThrowOnError extends boolean = false>(options?: Options<GetLocationServiceConsentUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetLocationServiceConsentUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-wello/location-service-consent',
        ...options
    });
};

/**
 * 위치 기반 동의 여부 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsent = <ThrowOnError extends boolean = false>(options?: Options<UpdateLocationServiceConsentUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateLocationServiceConsentUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-wello/location-service-consent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 개인 정보 수집 동의 여부 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsent = <ThrowOnError extends boolean = false>(options?: Options<GetPrivateDataConsentUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPrivateDataConsentUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-wello/private_data_consent',
        ...options
    });
};

/**
 * 개인 정보 수집 동의 여부 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsent = <ThrowOnError extends boolean = false>(options?: Options<UpdatePrivateDataConsentUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdatePrivateDataConsentUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member-wello/private_data_consent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 멤버 메세지 수신거부
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmessageDASHrejectSLASHmemberDASHwello = <ThrowOnError extends boolean = false>(options?: Options<RejectMessageUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<RejectMessageUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/message-reject/member-wello',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 정책 검색목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicy = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        querySerializer: {
            array: {
                explode: false,
                style: 'form'
            }
        },
        url: '/wello/v2/auth/policy',
        ...options
    });
};

/**
 * 로그인 멤버 정책 좋아요&스크랩 정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyFeedbackUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaPolicyFeedbackUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/feedback/{policy_id}',
        ...options
    });
};

/**
 * 관심 분야별 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicy = <ThrowOnError extends boolean = false>(options: Options<GetInterestPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInterestPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/interest-policy',
        ...options
    });
};

/**
 * 관련 정책 목록 조회(최대 7개)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated = <ThrowOnError extends boolean = false>(options: Options<GetRelatedMetaPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRelatedMetaPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/policy/{meta_policy_id_idx}/related',
        ...options
    });
};

/**
 * 회원 정책 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaPolicyUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/{meta_policy_id_idx}',
        ...options
    });
};

/**
 * 회원 마감 임박 맞춤 정책 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiry = <ThrowOnError extends boolean = false>(options: Options<GetRecommendNearExpiryPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRecommendNearExpiryPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/recommend/near-expiry',
        ...options
    });
};

/**
 * 회원 마감 임박 맞춤 정책 지원 유형 목록 조회(전체)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpirySLASHprovisionDASHtypes = <ThrowOnError extends boolean = false>(options?: Options<GetRecommendNearExpiryPolicyProvisionTypeAllListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRecommendNearExpiryPolicyProvisionTypeAllListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/recommend/near-expiry/provision-types',
        ...options
    });
};

/**
 * 회원 신규 맞춤 정책 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnew = <ThrowOnError extends boolean = false>(options: Options<GetRecommendNewPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRecommendNewPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/recommend/new',
        ...options
    });
};

/**
 * 회원 신규 맞춤 정책 지원 유형 목록 조회(전체)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewSLASHprovisionDASHtypes = <ThrowOnError extends boolean = false>(options?: Options<GetRecommendNewPolicyProvisionTypeAllListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRecommendNewPolicyProvisionTypeAllListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/recommend/new/provision-types',
        ...options
    });
};

/**
 * 회원 급상승 맞춤 정책 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrending = <ThrowOnError extends boolean = false>(options: Options<GetRecommendTrendingPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRecommendTrendingPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/recommend/trending',
        ...options
    });
};

/**
 * 회원 급상승 맞춤 정책 지원 유형 목록 조회(전체)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingSLASHprovisionDASHtypes = <ThrowOnError extends boolean = false>(options?: Options<GetRecommendTrendingPolicyProvisionTypeAllListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRecommendTrendingPolicyProvisionTypeAllListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/recommend/trending/provision-types',
        ...options
    });
};

/**
 * 회원 확인하지 않은 맞춤 정책 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunread = <ThrowOnError extends boolean = false>(options: Options<GetRecommendUnreadPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRecommendUnreadPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/recommend/unread',
        ...options
    });
};

/**
 * 회원 확인하지 않은 맞춤 정책 지원 유형 목록 조회(전체)
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadSLASHprovisionDASHtypes = <ThrowOnError extends boolean = false>(options?: Options<GetRecommendUnreadPolicyProvisionTypeAllListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRecommendUnreadPolicyProvisionTypeAllListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy/recommend/unread/provision-types',
        ...options
    });
};

/**
 * 혜택내역 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhis = <ThrowOnError extends boolean = false>(options?: Options<PaymentHisListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PaymentHisListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/payment-his',
        ...options
    });
};

/**
 * 총 리워드 지급 수
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisSLASHtotalDASHcount = <ThrowOnError extends boolean = false>(options?: Options<TotalPaymentHisListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TotalPaymentHisListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/payment-his/total-count',
        ...options
    });
};

/**
 * 포인트 정보 조회
 * 포인트 잔액, 출금 가능 포인트를 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpoint = <ThrowOnError extends boolean = false>(options?: Options<GetDetailPointBalanceUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDetailPointBalanceUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/point',
        ...options
    });
};

/**
 * 출석 내역 조회
 * 출석 내역 목록을 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendance = <ThrowOnError extends boolean = false>(options?: Options<GetListPointAttendanceUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetListPointAttendanceUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/point/attendance',
        ...options
    });
};

/**
 * 출석 체크
 * 오늘 날짜로 출석 내역을 저장합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendance = <ThrowOnError extends boolean = false>(options?: Options<SaveTodayAttendanceUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveTodayAttendanceUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/point/attendance',
        ...options
    });
};

/**
 * 포인트 이벤트 정보 조회
 * 포인트 이벤트 관련 정보를 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHevent = <ThrowOnError extends boolean = false>(options?: Options<GetPointBudgetUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPointBudgetUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/point/event',
        ...options
    });
};

/**
 * 포인트 사용, 출금, 차감 내역 조회
 * 포인트 사용, 출금, 차감 내역 목록을 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistory = <ThrowOnError extends boolean = false>(options: Options<GetListPointHistoryUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetListPointHistoryUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/point/history',
        ...options
    });
};

/**
 * 출금 신청
 * 원하는 금액의 출금을 신청합니다.
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHwithdrawal = <ThrowOnError extends boolean = false>(options: Options<SavePointWithdrawalUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SavePointWithdrawalUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/point/withdrawal',
        ...options
    });
};

/**
 * 랜덤티켓 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticket = <ThrowOnError extends boolean = false>(options: Options<GetRandomTicketListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRandomTicketListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/random-ticket',
        ...options
    });
};

/**
 * 랜덤티켓 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetRandomTicketUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRandomTicketUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/random-ticket/{random_ticket_id}',
        ...options
    });
};

/**
 * 랜덤티켓 오픈
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACESLASHopen = <ThrowOnError extends boolean = false>(options: Options<OpenRandomTicketUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<OpenRandomTicketUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/random-ticket/{random_ticket_id}/open',
        ...options
    });
};

/**
 * 랜덤티켓 - 럭키볼 소감 등록
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACESLASHreview = <ThrowOnError extends boolean = false>(options: Options<ReviewRandomTicketUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReviewRandomTicketUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/random-ticket/{random_ticket_id}/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 파일 삭제
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHs3 = <ThrowOnError extends boolean = false>(options?: Options<FileDeleteUsingDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<FileDeleteUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/s3',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 파일 업로드
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3 = <ThrowOnError extends boolean = false>(options?: Options<FileUploadUsingPost1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<FileUploadUsingPost1Response, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/s3',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * 파일 템프 저장 여부 상태 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHs3 = <ThrowOnError extends boolean = false>(options?: Options<UpdateFileTempSaveYnUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateFileTempSaveYnUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/s3',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 파일 복사
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHcopy = <ThrowOnError extends boolean = false>(options?: Options<FileCopyUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<FileCopyUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/s3/copy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 파일 복호화 다운로드
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHdecryption = <ThrowOnError extends boolean = false>(options: Options<FileDecryptionDownloadUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FileDecryptionDownloadUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/s3/decryption',
        ...options
    });
};

/**
 * 파일 재 업로드
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHre = <ThrowOnError extends boolean = false>(options?: Options<FileReUploadUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<FileReUploadUsingPostResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/s3/re',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * 파일 이름 변경
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHrename = <ThrowOnError extends boolean = false>(options?: Options<FileRenameUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<FileRenameUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/s3/rename',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 정책 꾸러미 목록 조회
 * 정책 꾸러미 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituation = <ThrowOnError extends boolean = false>(options?: Options<SituationListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SituationListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/situation',
        ...options
    });
};

/**
 * 정책 꾸러미 정책 목록 조회
 * 정책 꾸러미 정책 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetSituationPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSituationPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/situation/{situation_id}',
        ...options
    });
};

/**
 * 웰로 앱 푸시 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpush = <ThrowOnError extends boolean = false>(options: Options<GetWebWelloAppPushListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWebWelloAppPushListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-app-push',
        ...options
    });
};

/**
 * 웰로 앱 푸시 읽음 처리
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpush = <ThrowOnError extends boolean = false>(options?: Options<UpdateWelloAppPushReadUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateWelloAppPushReadUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-app-push',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 신청한 바로신청 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHapplyDASHpolicy = <ThrowOnError extends boolean = false>(options?: Options<GetWelloApplyPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWelloApplyPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/apply-policy',
        ...options
    });
};

/**
 * 웰로 댓글 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcomment = <ThrowOnError extends boolean = false>(options: Options<GetWelloCommentListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWelloCommentListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-comment',
        ...options
    });
};

/**
 * 웰로 댓글 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcomment = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloCommentUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloCommentUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-comment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * @deprecated
 * 웰로 실시간 정책 의견
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHlive = <ThrowOnError extends boolean = false>(options?: Options<GetLiveWelloCommentListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetLiveWelloCommentListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-comment/live',
        ...options
    });
};

/**
 * 웰로 유저가 작성한 댓글 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmy = <ThrowOnError extends boolean = false>(options: Options<GetMyWelloCommentListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMyWelloCommentListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-comment/my',
        ...options
    });
};

/**
 * 댓글 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetMetaPolicyCommentListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMetaPolicyCommentListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-comment/{welloCommentId}',
        ...options
    });
};

/**
 * 웰로 댓글 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloUNDERSCOREcommentUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<UpdateWelloCommentUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateWelloCommentUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-comment/{wello_comment_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 댓글 삭제
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloUNDERSCOREcommentUNDERSCOREidRBRACESLASHdelete = <ThrowOnError extends boolean = false>(options: Options<DeleteWelloCommentUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DeleteWelloCommentUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-comment/{wello_comment_id}/delete',
        ...options
    });
};

/**
 * 댓글 신고 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentDASHreport = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloCommentReportUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloCommentReportUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-comment-report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 가입 유저용 웰로 디바이스 정보 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHdeviceDASHinfo = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloDeviceInfoUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloDeviceInfoUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-device-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 헬퍼 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHhelper = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloHelperUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloHelperUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-helper',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 좋아요 삭제
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlike = <ThrowOnError extends boolean = false>(options?: Options<DeleteWelloLikeUsingDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteWelloLikeUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-like',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 좋아요 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlike = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloLikeUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloLikeUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-like',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 내가 좋아요한 글 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmy = <ThrowOnError extends boolean = false>(options: Options<GetListLikeContentsUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetListLikeContentsUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-like/my',
        ...options
    });
};

/**
 * 내가 좋아요한 글 유형 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmySLASHtype = <ThrowOnError extends boolean = false>(options?: Options<GetListLikeContentsTypeUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetListLikeContentsTypeUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-like/my/type',
        ...options
    });
};

/**
 * 웰로멤버 가족 프로필 삭제
 * 웰로멤버 삭제요청을 처리합니다
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHfamily = <ThrowOnError extends boolean = false>(options?: Options<DeleteWelloMemberFamilyUsingDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteWelloMemberFamilyUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/family',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로멤버 가족 목록 조회
 * 웰로멤버 가족 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile = <ThrowOnError extends boolean = false>(options?: Options<GetWelloMemberFamilyUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWelloMemberFamilyUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/family/profile',
        ...options
    });
};

/**
 * 웰로멤버 가족 프로필 추가
 * 웰로멤버 가족 프로필을 추가합니다
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloMemberFamilyUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloMemberFamilyUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/family/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로멤버 가족 프로필 수정
 * 웰로멤버 가족 프로필 정보를 수정합니다
 */
export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile = <ThrowOnError extends boolean = false>(options?: Options<UpdateWelloMemberFamilyUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateWelloMemberFamilyUsingPutResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/family/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 이벤트 참여
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHeventDASHparticipation = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloParticipationUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloParticipationUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-event-participation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 대상별 정책 - 대상 조회
 * 웰로 대상별 정책 - 대상 정보를 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpick = <ThrowOnError extends boolean = false>(options?: Options<WelloPickListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<WelloPickListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/pick',
        ...options
    });
};

/**
 * 웰로 대상별 정책 조회
 * 웰로 대상별 정책 정보를 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<WelloPickPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<WelloPickPolicyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/contents/pick/{wello_pick_id}',
        ...options
    });
};

/**
 * 정책 바로신청 체크
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHcheck = <ThrowOnError extends boolean = false>(options: Options<CheckWelloPolicyApplyUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckWelloPolicyApplyUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy-apply/check',
        ...options
    });
};

/**
 * 정책 바로신청 내역 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistory = <ThrowOnError extends boolean = false>(options?: Options<GetWelloPolicyApplyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWelloPolicyApplyListUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy-apply/history',
        ...options
    });
};

/**
 * 정책 바로신청 내역 수
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistorySLASHcount = <ThrowOnError extends boolean = false>(options?: Options<GetWelloPolicyApplyCountUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWelloPolicyApplyCountUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy-apply/history/count',
        ...options
    });
};

/**
 * 채무자신고 내역 저장 (각종 정보 제공 동의 및 채무자신고내역 저장)
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHreport = <ThrowOnError extends boolean = false>(options: Options<SaveReportUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveReportUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/policy-apply/report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 회원 트래킹 정보 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHtrack = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloTrackingUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloTrackingUsingPostResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/wello-track',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 스크랩 삭제
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlist = <ThrowOnError extends boolean = false>(options?: Options<DeleteWishlistUsingDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteWishlistUsingDeleteResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 스크랩 등록
 */
export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlist = <ThrowOnError extends boolean = false>(options?: Options<SaveWishlistUsingPost1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWishlistUsingPost1Response, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 정책소식 스크랩 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHbestDASHcontents = <ThrowOnError extends boolean = false>(options?: Options<BestContentsWishlistUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<BestContentsWishlistUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist/best-contents',
        ...options
    });
};

/**
 * 커뮤니티 스크랩 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunity = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityWishlistUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityWishlistUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist/community',
        ...options
    });
};

/**
 * 커뮤니티 스크랩 목록 조회 - 정책수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHpolicyDASHtalk = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityPolicyTalkWishlistUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityPolicyTalkWishlistUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist/community/policy-talk',
        ...options
    });
};

/**
 * 커뮤니티 스크랩 목록 조회 - 웰로소식
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHwelloDASHnews = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityWelloNewsWishlistUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityWelloNewsWishlistUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist/community/wello-news',
        ...options
    });
};

/**
 * 응급실 스크랩 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHemergencyDASHroom = <ThrowOnError extends boolean = false>(options?: Options<GetEmergencyRoomWishlistUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEmergencyRoomWishlistUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist/emergency-room',
        ...options
    });
};

/**
 * 동네소식 스크랩 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHhometownDASHnews = <ThrowOnError extends boolean = false>(options?: Options<HometownNewsWishlistUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HometownNewsWishlistUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist/hometown-news',
        ...options
    });
};

/**
 * 정책 스크랩 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHpolicy = <ThrowOnError extends boolean = false>(options?: Options<MetaPolicyWishlistUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MetaPolicyWishlistUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist/policy',
        ...options
    });
};

/**
 * 바우처 사용처 스크랩 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHvoucherDASHprovider = <ThrowOnError extends boolean = false>(options?: Options<VoucherProviderWishlistUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<VoucherProviderWishlistUsingGetResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'Authorization',
                type: 'apiKey'
            }
        ],
        url: '/wello/v2/auth/member/wishlist/voucher-provider',
        ...options
    });
};